import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xinzeng",
  "use": "icon-xinzeng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xinzeng\"><path d=\"M1024 512A512 512 0 11512 0a512 512 0 01512 512zm-245.12-40H552V245.12a40 40 0 00-80 0V472H245.12a40 40 0 000 80H472v226.88a40 40 0 1080 0V552h226.88a40 40 0 100-80z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol